
const Footer = () => {

    const date = new Date();

    return (
        <>
            <div className="flex-grow-1" />
            <footer className="footer mt-1">
                <p>
                    Copyright &copy; {date.getFullYear()} Big Yellow Self Storage Company.
                </p>
                <a href="https://www.bigyellow.co.uk/privacy-policy/" target="blank" >Privacy Policy</a>
            </footer>
        </>
    )
};

export default Footer;
